export default {
	"components.MakeAnOnlinePayment": "Make an online payment",
	"components.ClickOnTheUpperRightCornerOfTheScreen": "Click on the upper right corner of the screen",
	"components.SelectABrowserToOpenThisPage": ", select a browser to open this page"
}